import { capitalizeFirstLetter } from "./text"
import moment from 'moment'

export const getActiveCourse = (courses) => {
    if (!courses.length) return
    const courseId = window.location.pathname.split("/")[2]
    return courses.find((course) => courseId ? course.id === courseId : course.isCurrent === true)
}

export const getFullCourseName = (course) => {
    if (!course?.name) return
    return `${course.name} ${capitalizeFirstLetter(course.type)}`
}

export const getCourseNameFromCourseId = (courses, courseId) => {
    if (!courses.length || !courseId) return
    const course = courses.find((course) => course.id === courseId)
    return `${course.name} ${capitalizeFirstLetter(course.type)}`
}

export const getFormattedTimings = (currentCourse) => {
    return currentCourse.days + ' - '
    + moment(new Date(currentCourse.startDate)).format('LT')
    + ' - ' + moment(new Date(currentCourse.endDate)).format('LT')
}
